import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import classNames from 'classnames';

import { toJS, unwrap } from '../../../../utils/ChangeSpy';
import PrettyError from '../../../decorators/PrettyError';
import DisplayError from '../../../decorators/DisplayError';
import { Broad as BaseBroad } from '../../../Company/Details/Broad';
import { Users } from '../../CompanyBuyer/AddOnProjectCustom/MidPanel/Users';
import TradeShowUserAutoComplete from '../../../../containers/TradeShow/TradeShowUserAutoComplete';

import { Card } from '../../../helpers/Card';
import { TradeShowTextInput } from './TradeShowTextInput';

import style from './style.module.css';

const Broad = PrettyError(DisplayError(BaseBroad));

const TopBlockComponent = ({ data, onTextChange, models, tags, errors, onIndustryClick, onRowDelete }) => (
  <div className={style.host}>
    <Card className={style.details} title="Details">
      <div>
        <TradeShowTextInput
          error={errors.nameError}
          field={toJS(data.get('name'))}
          label="Trade Show / Industry Association"
          name="name"
          onTextChange={onTextChange}
        />
        <TradeShowTextInput
          error={errors.abbrError}
          field={toJS(data.get('abbr'))}
          label="Trade Show Abbreviated Name"
          name="abbr"
          onTextChange={onTextChange}
        />
        <TradeShowTextInput
          field={toJS(data.get('website'))}
          label="Website"
          name="website"
          onTextChange={onTextChange}
        />
      </div>
      <div className={style.description}>
        <TradeShowTextInput
          error={errors.descriptionError}
          field={toJS(data.get('description'))}
          label="Description"
          name="description"
          onTextChange={onTextChange}
        />
      </div>
    </Card>
    <Card
      className={classNames(style.industries, {
        [style.error]: errors.industryCategoriesError || errors.businessModelsError,
      })}
      flush
    >
      <Broad
        businessModels={models}
        data={tags}
        deprecatedIndustries={[]}
        headerClass={style.industriesHeader}
        onClick={onIndustryClick}
        canDisplayError
      />
    </Card>
    <Users
      className={classNames({ [style.error]: errors.usersError })}
      columnClassName={style.users}
      data={unwrap(data.get('users'))}
      editor={TradeShowUserAutoComplete}
      isFetching={data.get('isFetching')}
      onDelete={onRowDelete}
      canEditData
    />
  </div>
);

TopBlockComponent.propTypes = {
  data: PropTypes.instanceOf(Map).isRequired,
  errors: PropTypes.instanceOf(Object),
  models: PropTypes.instanceOf(Map).isRequired,
  onIndustryClick: PropTypes.func,
  onRowDelete: PropTypes.func,
  onTextChange: PropTypes.func,
  tags: PropTypes.instanceOf(Map).isRequired,
};

/** Top block component. */
export const TopBlock = memo(TopBlockComponent);
